import { useState } from 'react';
import { api } from '../utils/api';
import { useAuth } from '../context/AuthContext';

export default function MeuPerfil() {
  const { token, user } = useAuth();
  const [senhaAtual, setSenhaAtual] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [sucesso, setSucesso] = useState('');
  const [erro, setErro] = useState('');

  const trocarSenha = async (e) => {
    e.preventDefault();
    setErro(''); setSucesso('');
    if (novaSenha !== confirmar) { setErro('As senhas não conferem.'); return; }
    if (novaSenha.length < 6) { setErro('A nova senha deve ter pelo menos 6 caracteres.'); return; }
    setSalvando(true);
    try {
      await api.patch('/auth/senha', { senhaAtual, novaSenha }, token);
      setSucesso('Senha alterada com sucesso!');
      setSenhaAtual(''); setNovaSenha(''); setConfirmar('');
    } catch(err) {
      setErro(err.message || 'Erro ao alterar senha. Verifique a senha atual.');
    } finally { setSalvando(false); }
  };

  const initials = user?.nome?.split(' ').map(n=>n[0]).slice(0,2).join('').toUpperCase() || '?';

  return (
    <div style={{padding:'28px 32px',maxWidth:480}}>
      <div style={{marginBottom:24}}>
        <div style={{fontSize:22,fontWeight:700,letterSpacing:'-.02em'}}>Meu Perfil</div>
        <div style={{fontSize:13,color:'#6B7289',marginTop:3}}>Gerencie suas informações de acesso</div>
      </div>

      {/* Info do usuário */}
      <div className="card" style={{marginBottom:20,display:'flex',alignItems:'center',gap:16}}>
        <div style={{width:52,height:52,borderRadius:14,background:'#1A2ECC',display:'flex',alignItems:'center',justifyContent:'center',fontSize:18,fontWeight:700,color:'#fff',flexShrink:0}}>
          {initials}
        </div>
        <div>
          <div style={{fontSize:16,fontWeight:700}}>{user?.nome}</div>
          <div style={{fontSize:13,color:'#6B7289'}}>{user?.email}</div>
          <div style={{fontSize:11,color:'#9095A8',marginTop:2}}>{user?.turma || user?.role}</div>
        </div>
      </div>

      {/* Troca de senha */}
      <div className="card">
        <div style={{fontSize:14,fontWeight:700,marginBottom:16}}>Alterar senha</div>
        <form onSubmit={trocarSenha}>
          <div style={{marginBottom:14}}>
            <label style={{fontSize:12,fontWeight:500,color:'#6B7289',display:'block',marginBottom:5}}>Senha atual</label>
            <input className="input-field" type="password" placeholder="••••••••"
              value={senhaAtual} onChange={e=>setSenhaAtual(e.target.value)} required />
          </div>
          <div style={{marginBottom:14}}>
            <label style={{fontSize:12,fontWeight:500,color:'#6B7289',display:'block',marginBottom:5}}>Nova senha</label>
            <input className="input-field" type="password" placeholder="Mínimo 6 caracteres"
              value={novaSenha} onChange={e=>setNovaSenha(e.target.value)} required />
          </div>
          <div style={{marginBottom:20}}>
            <label style={{fontSize:12,fontWeight:500,color:'#6B7289',display:'block',marginBottom:5}}>Confirmar nova senha</label>
            <input className="input-field" type="password" placeholder="Repita a nova senha"
              value={confirmar} onChange={e=>setConfirmar(e.target.value)} required />
          </div>

          {sucesso && <div style={{background:'#E6F7F1',border:'0.5px solid #B8E6D2',borderRadius:8,padding:'10px 14px',fontSize:12,color:'#0A6B47',marginBottom:14}}>✅ {sucesso}</div>}
          {erro && <div style={{background:'#FDEAEA',border:'0.5px solid #E8A5A5',borderRadius:8,padding:'10px 14px',fontSize:12,color:'#922020',marginBottom:14}}>{erro}</div>}

          <button className="btn-primary" type="submit" disabled={salvando} style={{width:'100%',padding:13}}>
            {salvando ? 'Salvando...' : 'Alterar senha'}
          </button>
        </form>
      </div>
    </div>
  );
}
